module.exports = __webpack_public_path__ + "img/fs_wu.9bf60523.png";